import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const WishlistContext = createContext();
const BASE_URL = 'https://japanichiba.duckdns.org/api/v1/home/wishlist';

export const WishlistProvider = ({ children }) => {
    const [wishlist, setWishlist] = useState([]);
    const [isWishlistOpen, setIsWishlistOpen] = useState(false);

    // Giả định bạn lấy được userId từ hệ thống Auth (bạn có thể thay đổi cách lấy userId cho khớp dự án)
    const storedUser = localStorage.getItem('user');
    const userId = storedUser ? JSON.parse(storedUser).id : null;

    // 1. Tự động tải danh sách sản phẩm đã thích từ Database khi mở trang (F5 không mất)
    useEffect(() => {
        if (userId) {
            axios.get(`${BASE_URL}/${userId}`)
                .then(res => {
                    setWishlist(res.data || []); // Nhận về mảng ID [1, 2, 3...]
                })
                .catch(err => console.error("Lỗi lấy danh sách yêu thích từ DB:", err));
        }
    }, [userId]);

    // 2. Hàm Toggle xử lý gọi API lưu trực tiếp vào database
    const toggleWishlist = async (productId) => {
        if (!userId) {
            alert("Vui lòng đăng nhập để sử dụng tính năng yêu thích!");
            return;
        }

        // Cập nhật nhanh giao diện trước (Optimistic UI) để người dùng không cảm thấy bị chậm
        setWishlist((prev) =>
            prev.includes(productId) ? prev.filter((id) => id !== productId) : [...prev, productId]
        );

        try {
            // Gửi dữ liệu lên Backend xử lý lưu/xóa trong bảng wishlists
            await axios.post(`${BASE_URL}/toggle`, { userId, productId });
        } catch (error) {
            console.error("Lỗi khi đồng bộ trạng thái yêu thích với server:", error);
            // Nếu lỗi server thì khôi phục lại trạng thái cũ
            axios.get(`${BASE_URL}/${userId}`).then(res => setWishlist(res.data || []));
        }
    };

    const openWishlist = () => setIsWishlistOpen(true);
    const closeWishlist = () => setIsWishlistOpen(false);

    return (
        <WishlistContext.Provider value={{
            wishlist,
            toggleWishlist,
            isWishlistOpen,
            openWishlist,
            closeWishlist
        }}>
            {children}
        </WishlistContext.Provider>
    );
};

export const useWishlistContext = () => useContext(WishlistContext);
